import { render } from "./ActivityInfos.vue?vue&type=template&id=8aea2ea6"
import script from "./ActivityInfos.vue?vue&type=script&lang=js"
export * from "./ActivityInfos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__